export const permissoesUsuariosPropostas = {
  0: true,
  14: true,
  21: true,
  30: true,
  12: true,
  114: true,
}

export const permissoesUsuariosAbertura = {
  0: true,
  14: true,
  21: true,
  30: true,
  12: true,
  11: true,
  25: true,
  64: true,
  114: true,
}
